import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "components";

// Styled Components
const NotFoundContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: ${(props) => props.theme.spacing.xl}
    ${(props) => props.theme.spacing.lg};
  text-align: center;
`;

const NotFoundTitle = styled(motion.h1)`
  font-size: 8rem;
  font-weight: 800;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: ${(props) => props.theme.spacing.sm};
  line-height: 1;
`;

const NotFoundSubtitle = styled(motion.h2)`
  font-size: 2rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: ${(props) => props.theme.spacing.md};
`;

const NotFoundText = styled(motion.p)`
  color: ${(props) => props.theme.colors.textLight};
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: ${(props) => props.theme.spacing.lg};
`;

const ButtonGroup = styled(motion.div)`
  display: flex;
  gap: ${(props) => props.theme.spacing.sm};
  justify-content: center;
  flex-wrap: wrap;
`;

// Animation variants for title elements only

const titleVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

function NotFound() {
  return (
    <NotFoundContainer>
      <NotFoundTitle
        variants={titleVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.1 }}
      >
        404
      </NotFoundTitle>

      <NotFoundSubtitle
        variants={titleVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.2 }}
      >
        Page Not Found
      </NotFoundSubtitle>

      <NotFoundText
        variants={titleVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.3 }}
      >
        Oops! The page you're looking for doesn't exist. It might have been
        moved, deleted, or you entered the wrong URL.
      </NotFoundText>

      <ButtonGroup
        variants={titleVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.4 }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <Button variant="primary">Go Home</Button>
        </Link>
        <Link to="/contact" style={{ textDecoration: "none" }}>
          <Button variant="outline">Contact Us</Button>
        </Link>
      </ButtonGroup>
    </NotFoundContainer>
  );
}

export default NotFound;
